import React, { useState } from "react"
import {
	Grid,
	TextField,
	Typography
} from "@material-ui/core"

import { InfoDialog } from "@/components"
import VariableTableList from "@/components/ChatMessageBuilder/VariableInput/VariableTableList"
import { Variable } from "@/components/ChatMessageBuilder/VariableInput"

import { WABATemplateVariableIndexToVariableName } from "@/@integrations/WABA/protocols/wabaChannelMessageTemplate"

type WABATemplateVariableMappingFormProps = {
	unmappedVariableIndices: string[]
	availableVariables: Variable[]
	onMappingChange: (selectedVariableByIndex: WABATemplateVariableIndexToVariableName) => void
}

const WABATemplateVariableMappingForm: React.FC<WABATemplateVariableMappingFormProps> = (props) => {
	const {
		unmappedVariableIndices,
		availableVariables,
		onMappingChange
	} = props

	const [selectedVariableByIndex, setSelectedVariableByIndex] = useState<WABATemplateVariableIndexToVariableName>({})
	const [openDialogForIndex, setOpenDialogForIndex] = useState<string | null>(null)

	const handleVariableSelect = (variableValue: string) => {
		if (!openDialogForIndex) return

		const updated = {
			...selectedVariableByIndex,
			[openDialogForIndex]: variableValue
		}

		setSelectedVariableByIndex(updated)
		onMappingChange(updated)
		setOpenDialogForIndex(null)
	}

	return (
		<>
			<Grid container spacing={2} direction="column">
				<Grid item>
					<Typography variant="body2">
						Selecione qual variável da Letalk corresponde a cada uma:
					</Typography>
				</Grid>

				{unmappedVariableIndices.map((variableIndex) => (
					<Grid item key={variableIndex}>
						<TextField
							label={`Variável ${variableIndex}`}
							variant="outlined"
							size="small"
							fullWidth
							value={selectedVariableByIndex[variableIndex] ?? ""}
							inputProps={{ readOnly: true, style: { cursor: "pointer" } }}
							onClick={() => setOpenDialogForIndex(variableIndex)}
						/>
					</Grid>
				))}
			</Grid>

			<InfoDialog
				openDialog={Boolean(openDialogForIndex)}
				onClose={() => setOpenDialogForIndex(null)}
				title="Lista de Variáveis"
				maxWidth="sm"
			>
				<VariableTableList
					variables={availableVariables}
					onVariableSelected={handleVariableSelect}
				/>
			</InfoDialog>
		</>
	)
}

export default WABATemplateVariableMappingForm
